// GPS flag checklist criteria — copied 1:1 from StatusTrackerCell.buildGPSCriteriaList.

export const buildGPSCriteriaList = (playerACWRMeta) => {
    const numCriteria =
        ("num_over" in playerACWRMeta && playerACWRMeta["num_over"] >= 2) ||
        ("num_under" in playerACWRMeta && playerACWRMeta["num_under"] >= 2);
    const notInjuredInLatest3Dates =
        "injured_within_latest_3_date_range" in playerACWRMeta
            ? !playerACWRMeta["injured_within_latest_3_date_range"]
            : true;
    const numDaysInChronicRangeCheck =
        "chronic_range_min_count_check" in playerACWRMeta
            ? !playerACWRMeta["chronic_range_min_count_check"]
            : false;
    const notInjuredInChronicRange =
        "injured_within_chronic_range" in playerACWRMeta
            ? !playerACWRMeta["injured_within_chronic_range"]
            : true;
    const playerNotOnLeave =
        "player_on_leave" in playerACWRMeta ? !playerACWRMeta["player_on_leave"] : true;

    return [
        {
            condition: numCriteria,
            true_text: "2 or more key metrics outside ACWR limits for 3 consecutive training dates.",
            false_text:
                "ACWR is within limits or less than 2 key metrics are outside limits for 3 consecutive training dates.",
        },
        {
            condition: notInjuredInLatest3Dates,
            true_text: "Player is not injured on any of the 3 latest training dates.",
            false_text: "Player is injured on at least one of the 3 latest training dates.",
        },
        {
            condition: numDaysInChronicRangeCheck,
            true_text: "Player has atleast 12 days of data in the chronic range.",
            false_text: "Player has less than 12 days of data in the chronic range.",
        },
        {
            condition: notInjuredInChronicRange,
            true_text: "Player is not injured in the chronic range.",
            false_text: "Player is injured in the chronic range.",
        },
        {
            condition: playerNotOnLeave,
            true_text: "Player is not on leave.",
            false_text: "Player is on leave.",
        },
    ];
};
